// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__37e-R","checkboxCol":"Table_checkboxCol__1FlZt","emailCol":"Table_emailCol__3h5tk","actionCol":"Table_actionCol__1ZYRz"};